import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** 저장 HTML(레거시 문서 포함)의 태그·클래스로 맞춤 — 상세 표 머리글은 thead td */
export const SerpSeasonPlanRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    minWidth: 720,
  },
  '& section > table:first-of-type': {
    minWidth: 0,
  },
  '& section + section': {
    marginTop: 16,
  },
  '& colgroup col:last-of-type': {
    width: 120,
  },
  '& table th, & table td': {
    textAlign: 'center',
  },
  '& thead th:first-of-type': {
    textAlign: 'left',
    padding: '8px 12px',
  },
  '& .season-table thead td': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
    fontWeight: 500,
  },
  '& table .text-left': {
    textAlign: 'left',
  },
  '& table .text-right': {
    textAlign: 'right',
  },
}));
